import React from 'react'

import Circle from '../../public/svgs/circle.svg'
import Triangle from '../../public/svgs/triangele.svg'

import { CalendarLessonStatus } from '../../types/trialLessons'
export const Status = ({
  status,
  reservableCount,
  showLabel,
}: {
  status: CalendarLessonStatus
  reservableCount?: number
  showLabel?: boolean
}) => {
  switch (status) {
    case 'reservable':
      if (reservableCount === 1) {
        return (
          <>
            {showLabel ? (
              <span
                className="block text-white w-full leading-normal"
                style={{ fontSize: '8px', backgroundColor: '#d33955' }}
              >
                残り{reservableCount}名
              </span>
            ) : null}
            <img className="mx-auto" src={Triangle.src} />
          </>
        )
      }
      return <img className="mx-auto" src={Circle.src} />
    case 'none':
      return <span className="text-text-gray-3">-</span>
    case 'full':
      return <span className="text-text-gray-3 text-xs">満席</span>
    case 'reserved':
      return <span className="text-text-gray-3 text-xs">予約済</span>
  }
}
